import { getSupplierActivationStatus } from 'entities/CatalogItem';
import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { Vendor, VendorActivationStatus } from 'entities/Vendors';

const UNKNOWN_STATUS_SORT_ORDER = 4;

const STATUS_SORT_ORDER: Record<VendorActivationStatus, number> = {
    [VendorActivationStatus.VERIFIED]: 0,
    [VendorActivationStatus.VERIFYING]: 1,
    [VendorActivationStatus.INVALID]: 2,
    [VendorActivationStatus.INITIAL]: 3,
};

const getStatusSortOrder = (status: VendorActivationStatus | null): number => {
    if (!status) {
        return UNKNOWN_STATUS_SORT_ORDER;
    }

    return STATUS_SORT_ORDER[status] ?? UNKNOWN_STATUS_SORT_ORDER;
};

export const sortSupplierProposals = (
    proposals: Proposal[],
    vendorsMap: Record<string, Vendor> | null | undefined,
): Proposal[] => {
    return [...proposals].sort((firstProposal, secondProposal) => {
        const firstStatus = getSupplierActivationStatus(
            firstProposal,
            vendorsMap,
        );
        const secondStatus = getSupplierActivationStatus(
            secondProposal,
            vendorsMap,
        );

        const statusDifference =
            getStatusSortOrder(firstStatus) - getStatusSortOrder(secondStatus);

        if (statusDifference !== 0) {
            return statusDifference;
        }

        const nameDifference = firstProposal.seller.name.localeCompare(
            secondProposal.seller.name,
            undefined,
            { sensitivity: 'base' },
        );

        if (nameDifference !== 0) {
            return nameDifference;
        }

        return firstProposal.uid.localeCompare(secondProposal.uid);
    });
};
